import { UserAboutMe } from 'graphql.generated';
import React from 'react';

import { Dropdown, Label } from '@blueprint/ui';

import registrationAndSignInTranslations from 'public/locales/en/registration-and-sign-in.json';
import { getTranslator } from 'shared/i18n/getTranslator';

const translate = getTranslator(registrationAndSignInTranslations);
const aboutYouLabel = translate('aboutYouSection.aboutYouLabel');
const aboutYouDefaultOption = translate(
    'aboutYouSection.aboutYouDefaultOption'
);

interface AboutYouProps {
    dropDownRef?: () => void;
}

export const AboutYou = ({ dropDownRef }: AboutYouProps) => {
    return (
        <>
            <Label htmlFor="situation-dropdown">{aboutYouLabel}</Label>
            <Dropdown
                name="situation"
                id="situation-dropdown"
                ref={dropDownRef}
                data-testid="situation-dropdown"
            >
                <option value="">{aboutYouDefaultOption}</option>
                {Object.values(UserAboutMe)
                    .filter((statusKey) => statusKey !== UserAboutMe.Other)
                    .map((statusKey) => (
                        <option
                            value={statusKey}
                            key={`situation-${statusKey}`}
                        >
                            {translate(
                                `aboutYouSection.aboutYouOptions.${statusKey}`
                            )}
                        </option>
                    ))}
                <option value={UserAboutMe.Other}>
                    {translate(
                        `aboutYouSection.aboutYouOptions.${UserAboutMe.Other}`
                    )}
                </option>
            </Dropdown>
        </>
    );
};
